import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { hotComics } from '@/mocks/comics';

export default function PopularSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">
            <Link to="/category/all" className="hover:text-primary-500 transition-colors">热门推荐</Link>
          </h2>
          <p className="mt-1 text-sm text-foreground-500">千万读者口碑推荐，不可错过的精彩漫画</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
        {hotComics.slice(0, 5).map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}